// @ts-nocheck
/* Port of views/dashboard/module/CallGroupEditAclModal.js — byte-identical. */
import React, { useEffect, useState } from 'react';
import {
  CALL_GROUP_EDIT_OPTION_DEFS,
  normalizeCallGroupEditOptions,
} from '@/utilities/callGroupAcl';
import {
  AclSettingsModal,
  AclModalSection,
  AclModalOptionCheck,
  FaUsers,
} from '@/features/acl-settings/aclSettingsUi';

const CallGroupEditAclModal = ({
  show,
  onHide,
  initialOptions = [],
  onSave,
  optionDefs = CALL_GROUP_EDIT_OPTION_DEFS,
  limitedByParent = false,
}) => {
  const [selected, setSelected] = useState([]);
  const optionValues = optionDefs.map((o) => o.value);

  useEffect(() => {
    if (show) {
      const fromInitial = normalizeCallGroupEditOptions(initialOptions).filter((v) => optionValues.includes(v));
      const defaults = optionDefs.filter((o) => o.defaultOn !== false).map((o) => o.value);
      setSelected(fromInitial.length > 0 ? fromInitial : defaults);
    }
  }, [show, initialOptions, optionDefs]);

  const toggle = (value) => {
    setSelected((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value],
    );
  };

  const handleReset = () => setSelected([]);

  const handleSave = () => {
    onSave(selected);
    onHide();
  };

  return (
    <AclSettingsModal
      show={show}
      onHide={onHide}
      title="Call Group — Edit Options"
      icon={FaUsers}
      description="Select which call group settings users with this ACL can change when editing a call group."
      limitedByParent={limitedByParent}
      onSave={handleSave}
      onReset={handleReset}
      saveDisabled={selected.length === 0 || optionDefs.length === 0}
    >
      <AclModalSection
        icon={FaUsers}
        title="Call Group Settings"
        subtitle="Choose options allowed when editing call groups."
      >
        {optionDefs.length === 0 ? (
          <p className="acl-modal-empty">
            You do not have permission to grant any call group edit options.
          </p>
        ) : (
          optionDefs.map((opt) => (
            <AclModalOptionCheck
              key={opt.value}
              id={`cg-edit-${opt.value}`}
              label={opt.label}
              description={opt.description}
              checked={selected.includes(opt.value)}
              onChange={() => toggle(opt.value)}
            />
          ))
        )}
      </AclModalSection>
    </AclSettingsModal>
  );
};

export default CallGroupEditAclModal;
